"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Retrieve all the data sent by UI teams and call dataCollect to combine any global parameters and push to CoreSDK
var core_analytics_1 = require("@idp/core-analytics");
var common_analytics_manager_1 = require("./common-analytics-manager");
var utils_1 = require("./utils");
var LoginAppSdk = /** @class */ (function () {
    function LoginAppSdk() {
    }
    LoginAppSdk.reportEventToCoreSDK = function (iDTMEvent) {
        try {
            var updatedAnalyticsEvent = {
                eventAction: iDTMEvent.eventAction,
                eventCode: iDTMEvent.eventCode,
                additionaldata: iDTMEvent.additionaldata,
                datatransform: false,
                idp: true
            };
            this.checkEvents(updatedAnalyticsEvent);
        }
        catch (e) {
            console.error('An error occurred while trying to report an event to the SDK', e);
        }
    };
    LoginAppSdk.checkEvents = function (dtmAnalyticsEvent) {
        switch (dtmAnalyticsEvent.eventAction) {
            case common_analytics_manager_1.LoginEventActions.PAGE_LOAD:
                if (sessionStorage.getItem('loginPageLoadAnalyticsIDSE')) {
                    var sessionPageData = JSON.parse(sessionStorage.getItem('loginPageLoadAnalyticsIDSE'));
                    var urlData = dtmAnalyticsEvent.additionaldata;
                    if (sessionPageData['page.pageInfo.friendlyPageName']) {
                        delete sessionPageData['page.pageInfo.friendlyPageName'];
                    }
                    if (sessionPageData.friendlyPageName) {
                        delete sessionPageData.friendlyPageName;
                    }
                    if (urlData && urlData['page.pageInfo.flowCode']) {
                        sessionPageData['page.pageInfo.flowCode'] = urlData['page.pageInfo.flowCode'];
                    }
                    if (sessionPageData['page.location.url']) {
                        sessionPageData['page.location.url'] = urlData && urlData.url ? urlData.url : '';
                    }
                    dtmAnalyticsEvent.additionaldata = Object.assign(dtmAnalyticsEvent.additionaldata, sessionPageData);
                    core_analytics_1.CoreSDK.reportEvents(dtmAnalyticsEvent);
                }
                else {
                    core_analytics_1.CoreSDK.reportEvents(dtmAnalyticsEvent);
                }
                break;
            default:
                core_analytics_1.CoreSDK.reportEvents(dtmAnalyticsEvent);
        }
    };
    LoginAppSdk.checkAuth = function () {
        if (utils_1.Utils.getCookie('TATS-SS-TokenID')) {
            return true;
        }
        else if (utils_1.Utils.getCookie('tAuthNState')) {
            var tAuthNStateVal = utils_1.Utils.getCookie('tAuthNState') ? utils_1.Utils.getCookie('tAuthNState') : undefined;
            if (tAuthNStateVal) {
                var cookieVal = tAuthNStateVal.split('=');
                if (cookieVal[1]) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else if (utils_1.Utils.getCookie('cAuthNState')) {
            return true;
        }
        else {
            return false;
        }
    };
    LoginAppSdk.pageLoadData = {};
    LoginAppSdk.eventQueue = [];
    LoginAppSdk.pageLoadFire = true;
    return LoginAppSdk;
}());
exports.LoginAppSdk = LoginAppSdk;
//# sourceMappingURL=app-sdk.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@login/analytics/app-sdk.js
// module id = 1490
// module chunks = 8